import { FoodEnv, config } from '~/config'

export const ShowOnly: React.FC<{
  foodEnvs: FoodEnv[]
  children: React.ReactNode
}> = (props) => {
  if (props.foodEnvs.includes(config.foodEnv)) {
    return <>{props.children}</>
  } else {
    return null
  }
}
